import React, { ReactElement, useContext } from 'react';
import styled, { useTheme } from 'styled-components';

import { useMenu } from 'features/menu';
import { FullscreenContext } from 'features/fullscreen';

import { Box, ButtonIcon, ConditionalLink, Flex, Typography } from 'components';
import { createUrl, stripTags } from 'app/utils';
import { Link, useParams } from 'react-router-dom';
import { contentsTypes, useContents } from 'features/contents';
import { ProductTypeEnum, useProducts } from 'features/products';
import { ScormDownloads } from 'features/downloads';

export const TitleWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;

  :before {
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background: rgb(255, 255, 255);
    background: linear-gradient(80deg, rgba(255, 255, 255, 0) 0%, ${(props) => props.theme.colors.navbarBg} 100%);
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      :before {
        width: 50px;
      }

      ${mediaQueries.desktop} {
        :before {
          width: 70px;
        }
      }
    `;
  }}
`;

const DownloadsWrapper = styled(Flex)`
  position: absolute;
  top: calc(100% - 5px);
  border-radius: 4px;
  box-shadow: 5px 5px 10px 0px rgba (34, 60, 80, 0.2);
  display: none;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 280px;
      left: 10px;

      ${mediaQueries.desktop} {
        min-width: 250px;
        left: inherit;
        right: 10px;
      }
    `;
  }}
`;

const DownloadsArea = styled(Flex)`
  &:hover {
    ${DownloadsWrapper} {
      display: flex;
    }
  }
`;

const ContentNavbar = (): ReactElement => {
  const { backPathname, setMenuOpened } = useMenu();
  const { currentTheme, toggleTheme } = useTheme();
  const { toggleFullscreen, isFullscreen } = useContext(FullscreenContext);
  const { productSlug, productClassUuid } = useParams();
  const { contentDetails } = useContents();
  const { productDetails } = useProducts();

  return (
    <>
      <Flex
        bg="navbarBg"
        flexWrap="nowrap"
        flexDirection={{ m: 'column', d: 'row' }}
        borderBottomColor="gray_600"
        borderBottomStyle="solid"
        borderBottomWidth="1px"
        as="header"
      >
        <Flex flexWrap="nowrap" borderBottomColor="gray_600" borderBottomStyle="solid" borderBottomWidth={{ m: '1px', d: 0 }}>
          {/* {productDetails?.course?.isScorm && (
            <Link
              to={
                productSlug
                  ? contentDetails?.productType === ProductTypeEnum.MasterClass
                    ? createUrl('masterClassDetails', [productSlug, productClassUuid])
                    : productClassUuid
                    ? createUrl('productClassDetails', [productSlug, productClassUuid])
                    : createUrl('productDetails', [productSlug])
                  : backPathname
                  ? backPathname
                  : createUrl('dashboard')
              }
            >
              <ButtonIcon
                width={{ m: 60, d: 80 }}
                height={{ m: 60, d: 80 }}
                justifyContent="center"
                icon="close"
                size="large"
                bg="transparent"
                color="white"
                colorHover="primary_400"
                colorClick="primary_200"
                aria-label="Sair"
              />
            </Link>
          )}

          {!productDetails?.course?.isScorm && (
            <>
              {!!contentDetails?.productClassTimelineUuid ? (
                <>
                  {!contentDetails?.video?.isLiveMeeting ? (
                    <Link to={createUrl('productModule', [productSlug, productClassUuid, moduleUuid])}>
                      <ButtonIcon
                        width={{ m: 60, d: 80 }}
                        height={{ m: 60, d: 80 }}
                        justifyContent="center"
                        icon="close"
                        size="large"
                        bg="transparent"
                        color="white"
                        colorHover="primary_400"
                        colorClick="primary_200"
                        aria-label="Sair"
                      />
                      {/ * <ButtonIcon
                        width={{ m: 60, d: 80 }}
                        height={{ m: 60, d: 80 }}
                        justifyContent="center"
                        icon="dashboard"
                        onClick={() => setMenuOpened(false)}
                        size="large"
                        flexShrink={0}
                        bg="transparent"
                        bgHover="dark_350"
                        color="white"
                        borderLeftWidth={1}
                        borderLeftStyle="solid"
                        borderLeftColor="gray_600"
                        title={contentDetails && contentDetails.productClassTimelineName ? `Módulo: ${contentDetails.productClassTimelineName}` : ''}
                      /> * /}
                    </Link>
                  ) : (
                    <>
                      <Link
                        to={
                          productClassUuid
                            ? createUrl('productClassDetails', [productSlug, productClassUuid])
                            : createUrl('productDetails', [productSlug])
                        }
                      >
                        <ButtonIcon
                          width={{ m: 60, d: 80 }}
                          height={{ m: 60, d: 80 }}
                          justifyContent="center"
                          icon="close"
                          size="large"
                          bg="transparent"
                          color="white"
                          colorHover="primary_400"
                          colorClick="primary_200"
                          aria-label="Sair"
                        />
                        {/ * <ButtonIcon
                          width={{ m: 60, d: 80 }}
                          height={{ m: 60, d: 80 }}
                          justifyContent="center"
                          icon="dashboard"
                          onClick={() => setMenuOpened(false)}
                          size="large"
                          flexShrink={0}
                          bg="transparent"
                          bgHover="dark_350"
                          color="white"
                          borderLeftWidth={1}
                          borderLeftStyle="solid"
                          borderLeftColor="gray_600"
                          title="Ir para o curso"
                        /> * /}
                      </Link>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Link
                    to={
                      productSlug
                        ? contentDetails?.productType === ProductTypeEnum.MasterClass
                          ? createUrl('masterClassDetails', [productSlug, productClassUuid])
                          : productClassUuid
                          ? createUrl('productClassDetails', [productSlug, productClassUuid])
                          : createUrl('productDetails', [productSlug])
                        : backPathname
                        ? backPathname
                        : createUrl('dashboard')
                    }
                  >
                    <ButtonIcon
                      width={{ m: 60, d: 80 }}
                      height={{ m: 60, d: 80 }}
                      justifyContent="center"
                      icon="close"
                      size="large"
                      bg="transparent"
                      color="white"
                      colorHover="primary_400"
                      colorClick="primary_200"
                      aria-label="Sair"
                    />
                    {/ * <ButtonIcon
                      width={{ m: 60, d: 80 }}
                      height={{ m: 60, d: 80 }}
                      justifyContent="center"
                      icon="dashboard"
                      onClick={() => setMenuOpened(false)}
                      size="large"
                      flexShrink={0}
                      bg="transparent"
                      bgHover="dark_350"
                      color="white"
                      borderLeftWidth={1}
                      borderLeftStyle="solid"
                      borderLeftColor="gray_600"
                      title="Ir para o curso"
                    /> * /}
                  </Link>
                </>
              )}
            </>
          )} */}

          {productDetails?.course?.isScorm ? (
            <Link
              to={
                productSlug
                  ? contentDetails?.productType === ProductTypeEnum.MasterClass
                    ? createUrl('masterClassDetails', [productSlug, productClassUuid])
                    : productClassUuid
                    ? createUrl('productClassDetails', [productSlug, productClassUuid])
                    : createUrl('productDetails', [productSlug])
                  : backPathname
                  ? backPathname
                  : createUrl('dashboard')
              }
            >
              <ButtonIcon
                width={{ m: 60, d: 80 }}
                height={{ m: 60, d: 80 }}
                justifyContent="center"
                icon="close"
                size="large"
                bg="transparent"
                color="white"
                colorHover="primary_400"
                colorClick="primary_200"
                aria-label="Sair"
              />
            </Link>
          ) : (
            <>
              {window.history.length ? (
                <ButtonIcon
                  width={{ m: 60, d: 80 }}
                  height={{ m: 60, d: 80 }}
                  justifyContent="center"
                  icon="close"
                  size="large"
                  bg="transparent"
                  color="white"
                  colorHover="primary_400"
                  colorClick="primary_200"
                  aria-label="Sair"
                  onClick={() => window.history.back()}
                />
              ) : (
                <Link
                  to={
                    productSlug
                      ? contentDetails?.productType === ProductTypeEnum.MasterClass
                        ? createUrl('masterClassDetails', [productSlug, productClassUuid])
                        : productClassUuid
                        ? createUrl('productClassDetails', [productSlug, productClassUuid])
                        : createUrl('productDetails', [productSlug])
                      : backPathname
                      ? backPathname
                      : createUrl('dashboard')
                  }
                >
                  <ButtonIcon
                    width={{ m: 60, d: 80 }}
                    height={{ m: 60, d: 80 }}
                    justifyContent="center"
                    icon="close"
                    size="large"
                    bg="transparent"
                    color="white"
                    colorHover="primary_400"
                    colorClick="primary_200"
                    aria-label="Sair"
                  />
                </Link>
              )}
            </>
          )}

          <Box position="relative" borderLeftWidth="1px" borderLeftStyle="solid" borderLeftColor="gray_600">
            <TitleWrapper>
              <Flex flexDirection="column" pl={{ m: 20, t: 30 }}>
                <Typography as="h2" type="type1" upper color="white">
                  {productDetails?.course?.isScorm ? (
                    <>{productDetails?.product?.hat}</>
                  ) : (
                    <>
                      {Boolean(contentDetails && contentDetails.timelineOrder) && (
                        <>
                          {contentDetails.timelineOrder} / {contentDetails.timelineCount} •{` `}
                        </>
                      )}

                      {Boolean(contentDetails?.productClassTimelineName)
                        ? stripTags(contentDetails?.productClassTimelineName)
                        : !!contentDetails?.productName
                        ? stripTags(contentDetails?.productName)
                        : ''}
                    </>
                  )}
                </Typography>

                <Typography mt={{ m: 1, d: 2 }} as="h1" type="type5" fontWeight="bold" color="white">
                  {productDetails?.course?.isScorm ? stripTags(productDetails?.product?.name) : stripTags(contentDetails && contentDetails.name)}
                </Typography>
              </Flex>
            </TitleWrapper>
          </Box>
        </Flex>

        <Flex flexGrow={0}>
          {!productDetails?.course?.isScorm && (
            <ButtonIcon
              width={{ m: 60, d: 80 }}
              height={{ m: 60, d: 80 }}
              justifyContent="center"
              icon={currentTheme === 'light' ? 'themeLight' : 'themeDark'}
              onClick={toggleTheme}
              size="large"
              flexShrink={0}
              bg="transparent"
              bgHover="dark_350"
              color="white"
              borderLeftWidth={1}
              borderLeftStyle="solid"
              borderLeftColor="gray_600"
              title={currentTheme === 'light' ? 'Ver tema escuro' : 'ver tema claro'}
            />
          )}

          {productDetails?.course?.isScorm && !!productDetails?.downloads?.length && (
            <DownloadsArea flexGrow={0} position="relative">
              <ButtonIcon
                width={{ m: 60, d: 80 }}
                height={{ m: 60, d: 80 }}
                justifyContent="center"
                icon="download"
                size="large"
                flexShrink={0}
                bg="transparent"
                bgHover="dark_350"
                color="white"
                borderLeftWidth={1}
                borderLeftStyle="solid"
                borderLeftColor="gray_600"
                title="Downloads"
              />

              <DownloadsWrapper bg="dark_350">
                <ScormDownloads downloads={productDetails?.downloads} />
              </DownloadsWrapper>
            </DownloadsArea>
          )}

          {/* <ButtonIcon
            width={{ m: 60, d: 80 }}
            height={{ m: 60, d: 80 }}
            justifyContent="center"
            icon="fontUp"
            onClick={() => setMenuOpened(false)}
            size="large"
            flexShrink={0}
            bg="transparent"
            bgHover="dark_350"
            color="white"
            borderLeftWidth={1}
            borderLeftStyle="solid"
            borderLeftColor="gray_600"
          />
          <ButtonIcon
            width={{ m: 60, d: 80 }}
            height={{ m: 60, d: 80 }}
            justifyContent="center"
            icon="fontDown"
            onClick={() => setMenuOpened(false)}
            size="large"
            flexShrink={0}
            bg="transparent"
            bgHover="dark_350"
            color="white"
            borderLeftWidth={1}
            borderLeftStyle="solid"
            borderLeftColor="gray_600"
          /> */}

          <Box flexGrow={0} display={{ m: 'none', d: 'block' }}>
            <ButtonIcon
              width={{ m: 60, d: 80 }}
              height={{ m: 60, d: 80 }}
              justifyContent="center"
              icon={isFullscreen ? 'fullscreenOff' : 'fullscreenOn'}
              onClick={toggleFullscreen}
              size="large"
              flexShrink={0}
              bg="transparent"
              bgHover="dark_350"
              color="white"
              borderLeftWidth={1}
              borderLeftStyle="solid"
              borderLeftColor="gray_600"
              title={isFullscreen ? 'Minimizar' : 'Maximizar'}
            />
          </Box>

          {Boolean(contentDetails && contentDetails.previousContentUuid) && (
            <ConditionalLink
              to={createUrl(
                contentDetails.productType === ProductTypeEnum.Course
                  ? contentDetails.previousProductClassTimelineUuid
                    ? 'contentClassDetails'
                    : 'productContentClassDetails'
                  : 'productNoClassContent',
                [
                  productSlug,
                  productClassUuid,
                  contentDetails.previousProductClassTimelineUuid,
                  contentDetails.previousContentUuid,
                  contentsTypes(contentDetails.previousContentType, contentDetails.previousExternalDocumentType),
                ]
              )}
              type="internal"
              replace
            >
              <ButtonIcon
                width={{ m: 60, d: 80 }}
                height={{ m: 60, d: 80 }}
                justifyContent="center"
                icon="chevronLeft"
                onClick={() => setMenuOpened(false)}
                size="large"
                flexShrink={0}
                bg="transparent"
                bgHover="dark_350"
                color="white"
                borderLeftWidth={1}
                borderLeftStyle="solid"
                borderLeftColor="gray_600"
                title={`${
                  contentDetails.previousProductClassTimelineName ? `${stripTags(contentDetails.previousProductClassTimelineName)} - ` : ''
                }${stripTags(contentDetails.previousContentName)}`}
                style={{ whiteSpace: 'pre' }}
              />
            </ConditionalLink>
          )}

          {Boolean(contentDetails && contentDetails.nextContentUuid) && (
            <ConditionalLink
              to={createUrl(
                contentDetails.productType === ProductTypeEnum.Course
                  ? contentDetails.nextProductClassTimelineUuid
                    ? 'contentClassDetails'
                    : 'productContentClassDetails'
                  : 'productNoClassContent',
                [
                  productSlug,
                  productClassUuid,
                  contentDetails.nextProductClassTimelineUuid,
                  contentDetails.nextContentUuid,
                  contentsTypes(contentDetails.nextContentType, contentDetails.nextExternalDocumentType),
                ]
              )}
              type="internal"
              replace
            >
              <ButtonIcon
                width={{ m: 60, d: 80 }}
                height={{ m: 60, d: 80 }}
                justifyContent="center"
                icon="chevronRight"
                onClick={() => setMenuOpened(false)}
                size="large"
                flexShrink={0}
                bg="transparent"
                bgHover="dark_350"
                color="white"
                borderLeftWidth={1}
                borderLeftStyle="solid"
                borderLeftColor="gray_600"
                borderRightWidth={1}
                borderRightStyle="solid"
                borderRightColor="gray_600"
                title={`${
                  contentDetails.nextProductClassTimelineName ? `${stripTags(contentDetails.nextProductClassTimelineName)} - ` : ''
                }${stripTags(contentDetails.nextContentName)}`}
              />
            </ConditionalLink>
          )}
        </Flex>
      </Flex>
    </>
  );
};
export default ContentNavbar;
